// eslint-disable-next-line import/prefer-default-export
export const getLastMessageToken = (id: string) => `lastMessage_${id}`;

